import React, { useState, useEffect } from 'react';
import axios from 'axios';
import JsBarcode from 'jsbarcode';
import '../styles/armsform.css';

const SDSRForm = () => {
    const [formData, setFormData] = useState({
        token_id: 'token_',
        dsr_no: '',
        dated: '',
        subject: '',
        location: '',
        timings: '',
        approximate_strength: '',
        prominent_speakers: '',
        hate_speech: '',
        security_arrangements: '',
        special_activity: '',
        statement: '',
        copy_to: '',
        district: ''
    });
    const [barcode, setBarcode] = useState('');
    const [message, setMessage] = useState('');
    const [showPopup, setShowPopup] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    useEffect(() => {
        if (formData.token_id) {
            const canvas = document.createElement('canvas');
            JsBarcode(canvas, formData.token_id, {
                format: 'CODE128',
                width: 2,
                height: 50,
                displayValue: true,
            });
            setBarcode(canvas.toDataURL('image/png'));
        }
    }, [formData.token_id]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post('https://ourzest.com/dsr_backend/s-dsr.php', {
                action: 'add',
                ...formData,
            });

            if (response.data.status === 'success') {
                setMessage(response.data.message);
                setFormData({
                    token_id: '',
                    dsr_no: '',
                    dated: '',
                    subject: '',
                    location: '',
                    timings: '',
                    approximate_strength: '',
                    prominent_speakers: '',
                    hate_speech: '',
                    security_arrangements: '',
                    special_activity: '',
                    statement: '',
                    copy_to: '',
                    district: '',
                });

                setShowPopup(true);
                setTimeout(() => setShowPopup(false), 2000);
            } else {
                setMessage(response.data.message || 'Error submitting form');
            }
        } catch (error) {
            setMessage('An error occurred while submitting the form');
            console.error(error);
        }
    };

    return (
        <div className="lc-form-container">
            <form className="lc-form" onSubmit={handleSubmit}>
                <div className="lc-left-section">
                    <div className="lc-form-group">
                        <label className="lc-label">Token ID</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="token_id"
                                value={formData.token_id}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">District</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="district"
                                value={formData.district}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">DSR No</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="dsr_no"
                                value={formData.dsr_no}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Dated</label>
                        <div className="lc-input-container">
                            <input
                                type="date"
                                name="dated"
                                value={formData.dated}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Subject</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Location</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="location"
                                value={formData.location}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Timings</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="timings"
                                value={formData.timings}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Approximate Strength</label>
                        <div className="lc-input-container">
                            <input
                                type="number"
                                name="approximate_strength"
                                value={formData.approximate_strength}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <button type="submit" className="lc-submit-btn">Submit</button>
                </div>
                <div className="lc-right-section">
                    <div className="lc-form-group">
                        <label className="lc-label">Prominent Speakers</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="prominent_speakers"
                                value={formData.prominent_speakers}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Hate Speech / Anti-State Sentiments by speakers</label>
                        <div className="lc-input-container">
                            <input
                                name="hate_speech"
                                value={formData.hate_speech}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Security Arrangements</label>
                        <div className="lc-input-container">
                            <input
                                name="security_arrangements"
                                value={formData.security_arrangements}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Any Special Activity</label>
                        <div className="lc-input-container">
                            <input
                                name="special_activity"
                                value={formData.special_activity}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Statement</label>
                        <div className="lc-input-container">
                            <input
                                name="statement"
                                value={formData.statement}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Copy TO</label>
                        <div className="lc-input-container">
                            <textarea
                                name="copy_to"
                                value={formData.copy_to}
                                onChange={handleChange}
                                className="lc-input"
                                style={{ borderRadius: '6px', minHeight: '100px' }}
                            />
                        </div>
                    </div>
                </div>
            </form>

            {/* {barcode && (
                <div className="lc-barcode-container">
                    <img src={barcode} alt="Barcode" className="lc-barcode" />
                </div>
            )} */}

            {showPopup && (
                <div className="lc-popup">
                    Data saved successfully!
                </div>
            )}
        </div>
    );
};

export default SDSRForm;